import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase, Smartphone, TrendingUp } from 'lucide-react';
export function ForWhoSection() {
  const profiles = [{
    icon: <Briefcase className="w-8 h-8 text-navy mb-4" strokeWidth={1.5} data-id="element-57" />,
    text: 'Agencias de viajes que quieren mejorar su comunicación en ventas'
  }, {
    icon: <Smartphone className="w-8 h-8 text-navy mb-4" strokeWidth={1.5} data-id="element-58" />,
    text: 'Vendedores de agencias de viaje'
  }, {
    icon: <TrendingUp className="w-8 h-8 text-navy mb-4" strokeWidth={1.5} data-id="element-59" />,
    text: 'Vendedores que quieran mejorar su tasa de conversión'
  }];
  return <section className="bg-cream text-navy py-24 px-5" data-id="element-60">
      <div className="max-w-5xl mx-auto" data-id="element-61">
        <div className="text-center mb-16" data-id="element-62">
          <h2 className="font-playfair text-3xl md:text-5xl font-bold mb-4" data-id="element-63">
            ¿Para quién es este material?
          </h2>
          <div className="w-12 h-1 bg-gold mx-auto" data-id="element-64"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-65">
          {profiles.map((profile, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-10 rounded border border-gold/10 flex flex-col items-center text-center shadow-sm" data-id="element-66">
              {profile.icon}
              <p className="font-playfair text-xl font-medium leading-snug" data-id="element-67">
                {profile.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}